const ddadosHistorico = {
  Titulo: "Histórico",
  Campos: {
    //DDados Histório
    DataHistorico: {
      Tipo: "date",
      Label: "Data",
      Obrigatorio: true
    },
    Historico: {
      Tipo: "textarea",
      Label: "Histórico",
      Tamanho: 2000
    },
    Origem: {
      Tipo: "text",
      Label: "Origem",
      ValorInicial: "Solicitante/Prefeitura",
      Desabilitado: true
    },
    VisivelUsuario: {
      Tipo: "checkbox",
      Label: "Visível ao Usuário"
    }
  }
}

export { ddadosHistorico }
